export default "__VITE_ASSET__D5wT_Nkk__"